
import { get } from 'helpers/api';

const rootPath = '/integrations/quickbooks/account';

export async function search({ type, ...fields }, callback) {
  const results = await get(`${rootPath}/search`, { params: { type, ...fields } });
  callback(results);
}

export async function loadObject({ type, id }, callback) {
  const result = await get(`${rootPath}/object/${type}/${id}`);
  callback(result);
}
